import React, { useState } from "react"
import styled from "styled-components"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import Icon from "./icon"

const Dropdown = ({ button, options }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleButtonClick = (click = () => {}) => {
    click()
    handleClose()
  }

  return (
    <div>
      {button(handleClick)}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        {options.map((option, index) => (
          <StyledMenuItem key={index} onClick={() => handleButtonClick(option.onClick)}>
            {option.icon && <Icon icon={option.icon} />}
            {option.text}
          </StyledMenuItem>
        ))}
      </Menu>
    </div>
  )
}

export default Dropdown

const StyledMenuItem = styled(MenuItem)`
  font-size: ${({ theme }) => theme.font.M} !important;
  font-weight: ${({ theme }) => theme.font.normal} !important;
  min-height: min-content !important;

  svg {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
`
